import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
export var Component = function Component(_ref) {
  var alignContent = _ref.alignContent,
      alignItems = _ref.alignItems,
      children = _ref.children,
      className = _ref.className,
      flexDirection = _ref.flexDirection,
      flexWrap = _ref.flexWrap,
      justifyContent = _ref.justifyContent;
  return React.createElement("div", {
    className: classnames('flex-container', className),
    style: {
      display: 'flex',
      flexGrow: '1',
      height: '100%',
      alignContent: alignContent,
      alignItems: alignItems,
      flexDirection: flexDirection,
      flexWrap: flexWrap,
      justifyContent: justifyContent
    }
  }, children);
};
Component.displayName = 'FlexContainer';
Component.defaultProps = {
  alignContent: null,
  alignItems: null,
  className: null,
  flexDirection: null,
  flexWrap: null,
  justifyContent: null
};
Component.propTypes = process.env.NODE_ENV !== "production" ? {
  alignContent: PropTypes.oneOf(['flex-start', 'flex-end', 'center', 'space-between', 'space-around', 'stretch']),
  alignItems: PropTypes.oneOf(['flex-start', 'flex-end', 'center', 'baseline', 'stretch']),
  children: PropTypes.node.isRequired,
  className: PropTypes.string,
  flexDirection: PropTypes.oneOf(['row', 'row-reverse', 'column', 'column-reverse']),
  flexWrap: PropTypes.oneOf(['nowrap', 'wrap', 'wrap-reverse']),
  justifyContent: PropTypes.oneOf(['flex-start', 'flex-end', 'center', 'space-between', 'space-around', 'space-evenly'])
} : {};